export const maskEmail = (email: string) => {
  const [name, domain] = email.split("@");
  if (!domain) return email;

  const visibleCount = name.length <= 2 ? 1 : 2;
  const visible = name.slice(0, visibleCount);
  const maskedLength = Math.max(name.length - visibleCount, 1);
  return `${visible}${"*".repeat(maskedLength)}@${domain}`;
};
